import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    sessionId: null,
    isChatPage: false,
  },
  reducers: {
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setIsChatPage: (state, action) => {
      state.isChatPage = action.payload;
    },
  },
});

export const { setSessionId, setIsChatPage  } = sessionSlice.actions;
export default sessionSlice.reducer;
